<template>
	<div class="error-page">
		<div
			class="container-fluid min-vh-100 d-flex align-items-center justify-content-center py-5"
		>
			<div class="row w-100 justify-content-center">
				<div class="col-xl-4 col-lg-6 col-md-6 col-sm-10">
					<div class="card error-card border-0 text-center">
						<div class="card-body p-4 p-md-5">
							<div class="error-icon mx-auto mb-4 bg-soft-info">
								<i class="mdi mdi-map-marker-question-outline text-info"></i>
							</div>
							<p class="text-info font-weight-bold text-uppercase mb-1 font-size-16">
								{{ $t('message.error') }} 404
							</p>
							<h1 class="font-weight-bold mb-0 display-2">
								404
							</h1>
							<h2 class="h3 font-weight-bold mb-4">
								{{ $t('label.pageNotFound') }}
							</h2>
							<div
								class="d-flex flex-column flex-sm-row justify-content-center col-12"
							>
                                <router-link
                                    to="/"
                                    class="btn btn-info col-md-6 mx-1 mb-2"
                                >
                                    <i class="mdi mdi-home-outline mr-1 font-size-18"></i>
                                    {{ $t('label.home') }}
                                </router-link>
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary col-md-6 mx-1 mb-2"
                                    @click="goBack"
                                >
                                    <i class="mdi mdi-arrow-left mr-1 font-size-18"></i>
                                    {{ $t('label.back') }}
                                </button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import store from '@/state/store';

let refresh = true;
export default {
	name: 'Error404',
	async created() {
		await this.refreshCredential();
	},
	methods: {
		goBack() {
			if (window.history.length > 1) {
				this.$router.go(-1);
				return;
			}

			this.$router.push('/');
		},
		async refreshCredential() {
			if (refresh) return;
			refresh = true;
			await store.dispatch('api/auth/logout');
			await store.dispatch('app/auth/logout');
		},
	},
};
</script>

<style scoped>
.error-page {
	min-height: 100vh;
	background:
		linear-gradient(rgba(248, 250, 252, 0.94), rgba(238, 245, 249, 0.94)),
		url("https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png")
			center / min(1300px, 150vw) no-repeat;
}

.error-card {
	border-radius: 20px;
	background: rgba(255, 255, 255, 0.94);
	box-shadow: 0 20px 60px rgba(31, 45, 61, 0.12);
}

.error-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 80px;
	height: 80px;
	border-radius: 50%;
	font-size: 44px;
}

.error-description {
	max-width: 460px;
	line-height: 1.7;
}
</style>